import React from 'react';
import { Grid, Skeleton, Stack } from '@mui/material';

import { TREND_COLORS } from '../trendTheme';

type TrendCardSkeletonGridProps = {
  count?: number;
  withImage?: boolean;
};

/**
 * Skeleton grid shown while cards/lists load, replacing bare spinners for a
 * calmer, less "jumpy" loading experience.
 */
export default function TrendCardSkeletonGrid({ count = 6, withImage = true }: TrendCardSkeletonGridProps) {
  return (
    <Grid container spacing={3}>
      {Array.from({ length: count }).map((_unused, index) => (
        <Grid key={index} size={{ xs: 12, sm: 6, lg: 4 }}>
          <Stack
            spacing={1.25}
            sx={{
              p: 2,
              borderRadius: 3,
              border: `1px solid ${TREND_COLORS.divider}`,
              bgcolor: TREND_COLORS.cardBg,
            }}
          >
            {withImage && <Skeleton variant="rounded" height={150} sx={{ borderRadius: 2 }} />}
            <Skeleton variant="text" width="40%" height={20} />
            <Skeleton variant="text" width="90%" height={28} />
            <Skeleton variant="text" width="100%" />
            <Skeleton variant="text" width="75%" />
          </Stack>
        </Grid>
      ))}
    </Grid>
  );
}
